var { initIframePrint } = require('./shared/iframe-print');

/**
 * Event Checklist - JavaScript functionality
 * Handles item toggling and adding items
 */
(function () {
    'use strict';

    /**
     * Submit toggle item form
     * @param {number} categoryIndex - The category index
     * @param {number} itemIndex - The item index
     */
    function submitToggle(categoryIndex, itemIndex) {
        document.getElementById('toggleCategoryIndex').value = categoryIndex;
        document.getElementById('toggleItemIndex').value = itemIndex;
        document.getElementById('toggleForm').submit();
    }

    /**
     * Submit add item form
     * @param {number} categoryIndex - The category index
     */
    function submitAddItem(categoryIndex) {
        const input = document.getElementById('addItem-' + categoryIndex);
        const text = input.value.trim();
        if (text === '') {
            input.focus();
            return;
        }
        document.getElementById('addItemText').value = text;
        document.getElementById('addItemCategoryIndex').value = categoryIndex;
        document.getElementById('addItemForm').submit();
    }

    /**
     * Initialize event listeners
     */
    function init() {
        // Delegate add-item button clicks via data-category-index
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-category-index]');
            if (btn) {
                submitAddItem(parseInt(btn.getAttribute('data-category-index'), 10));
            }
        });

        initIframePrint({
            formId: 'ecPrintForm',
            iframeId: 'ecPrintFrame',
            buttonId: 'ecPrintBtn',
            readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Checklist',
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose public API
    window.EventChecklist = {
        submitToggle: submitToggle,
        submitAddItem: submitAddItem
    };
})();
